import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import Icon from 'material-ui/Icon';

const markdown = require( "markdown" ).markdown;

function createMarkup(html) {
  return { __html: html };
}

const LoadHtml = ({ handleCloseClick, handleHTMLClick, isopen, tag }) => {
  const contents = require('../../../content.json');
  let content = '';
  let title = '';
  if (tag) {
    tag = tag.replace('+', ',');
  }

  for (const item of contents) {
    if (item.tags === tag) {
      title = item.title;
      content = item.body;
    }
  }
  content = markdown.toHTML(content);

  return (
    <Drawer
      open={isopen}
      className="html-drawer"
      type="persistent"
    >
      <div className="html-content">
        <h1>{title}</h1>
        <div onClick={(event) => handleHTMLClick(event)} dangerouslySetInnerHTML={createMarkup(content)} />
        <Icon color="action" onClick={handleCloseClick} className="close-icon">close</Icon>
      </div>
    </Drawer>
  );
};

LoadHtml.propTypes = {
  handleCloseClick: PropTypes.func,
  handleHTMLClick: PropTypes.func,
  isopen: PropTypes.bool,
  tag: PropTypes.string,
};

export default LoadHtml;



// WEBPACK FOOTER //
// ./scripts/components/LoadHtml.jsx